import React, { PropsWithChildren } from 'react';

import { GatsbyLinkProps, Link } from 'gatsby';
import { getLocalizedPath } from '~/src/common/navigation';
import { useLocale } from '~/src/components/LocaleProvider';
import type { Omit } from '~/types';

// Omitting 'ref' due to Link <-> HTMLAnchorElement incompatibility, but could be included if fixed
type GatsbyLinkPropsNoRef<TState = null> = Omit<GatsbyLinkProps<TState>, 'ref'>;
type Props = GatsbyLinkPropsNoRef & { doNotLocalize?: boolean };
export type LocalizedLinkExternalProps<TState = null> = GatsbyLinkPropsNoRef<TState>;

export const LocalizedLink: React.FC<PropsWithChildren<Props>> = ({
  to,
  doNotLocalize = false,
  ...props
}) => {
  const { locale } = useLocale();

  if (to?.startsWith('http')) {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a href={to} {...props} />;
  }

  const path = doNotLocalize ? to : getLocalizedPath(to, locale);
  return <Link {...props} to={path} />;
};
